<template>
  <nav v-if="user" class="navbar navbar-expand-lg navbar-light">
    <div class="container col-12">
      <router-link :to="{ name: user ? 'home' : 'welcome' }" class="navbar-brand">
        <!-- {{ appName }} -->
        <img alt="Logo da Empresa" :src="logo" class="imagem-emp">
      </router-link>

      <button id="btn-navbar-toggler" v-b-toggle="'navbarToggler'" class="navbar-toggler border-0" type="button">
        <span class="navbar-toggler-icon" />
      </button>

      <b-collapse id="navbarToggler" visible class="m-auto mx-xl-0 mx-lg-0 mx-md-0">
        <!-- <ul class="navbar-nav">
          <locale-dropdown/> -->
        <!-- <li class="nav-item">
            <a class="nav-link" href="#">Link</a>
          </li> -->
        <!-- </ul> -->

        <ul class="navbar-nav ml-auto">
          <!-- Authenticated -->
          <li v-if="user.emp.agendamentos" class="nav-item align-self-center">
            <router-link :to="{ name: 'agendar' }" class="pl-3 nav-link" style="width: fit-content">
              {{ $t('agendar_horario') }}
            </router-link>
          </li>
          <li v-if="user.emp.agendamentos" class="nav-item align-self-center position-relative">
            <span v-show="countPendentes > 0" class="bolinha">
              <span>{{ countPendentes }}</span>
            </span>
            <router-link :to="{ name: 'agendamentos' }" class="pl-3 nav-link" style="width: fit-content">
              {{ $t('agendamentos') }}
            </router-link>
          </li>
          <li v-if="user.emp.pedidos" class="nav-item align-self-center position-relative">
            <span v-show="countPedidos > 0" class="bolinha">
              <span>{{ countPedidos }}</span>
            </span>
            <router-link :to="{ name: 'pedidos' }" class="pl-3 nav-link" style="width: fit-content">
              {{ $t('pedidos') }}
            </router-link>
          </li>

          <b-dropdown class="show" variant="transparent" boundary="viewport">
            <template slot="button-content" class="btn text-center">
              <!-- <img :src="user.photo_url" class="rounded-circle profile-photo mr-1"> -->
              {{ user.name }}
            </template>
            <b-dropdown-item :to="{ name: 'config.profile' }">
              <fa icon="cog" fixed-width /> {{ $t('settings') }}
            </b-dropdown-item>
            <b-dropdown-item :href="'#'" @click.prevent="logout">
              <fa icon="sign-out-alt" fixed-width /> {{ $t('logout') }}
            </b-dropdown-item>
          </b-dropdown>

          <!-- Guest -->
          <!-- <template v-else>
            <li class="nav-item">
              <router-link :to="{ name: 'login' }" class="nav-link" active-class="active">
                {{ $t('login') }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'register' }" class="nav-link" active-class="active">
                {{ $t('register') }}
              </router-link>
            </li>
          </template> -->
        </ul>
      </b-collapse>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";
// import LocaleDropdown from "./LocaleDropdown";
import axios from "axios";

export default {
  // components: {
  //   LocaleDropdown
  // },

  data: () => ({
    appName: window.config.appName,
    countPendentes: null,
    countPedidos: null,
    intervalSearch: null
  }),

  computed: mapGetters({
    user: "auth/user",
    logo: "app/logo"
  }),

  created() {
    clearInterval(this.intervalSearch);
    let intervalo = 5;
    let minuto = 60000;
    this.contarPendentes();
    this.contarPedidos();

    this.intervalSearch = setInterval(() => {
      this.contarPendentes();
      this.contarPedidos();
    }, intervalo * minuto);
  },

  methods: {
    async logout() {
      // Log out the user.
      await this.$store.dispatch("auth/logout");

      // Redirect to login.
      this.$router.push({
        name: "login"
      });
    },
    contarPendentes() {
      axios.get("/api/agendamento/pendentes/count").then(({ data }) => {
        this.countPendentes = data;
      });
    },
    contarPedidos() {
      axios.get("/api/pedido/count").then(({ data }) => {
        this.countPedidos = data;
      });
    }
  }
};
</script>

<style scoped>
.profile-photo {
  width: 2rem;
  height: 2rem;
  margin: -0.375rem 0;
}

.bolinha {
  position: absolute !important;
  top: -5px;
  right: -5px;
  background: #da7900;
  border-radius: 50%;
  padding: 10px 10px;
  text-align: center;
  vertical-align: middle;
  position: relative;
  color: #ffffff;
  font-size: 11px;
}

.bolinha>span {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.navbar {
  background: rgba(255, 255, 255, 0.5);
}

.imagem-emp {
  max-height: 55px;
}

#btn-navbar-toggler {
  outline: none;
}

@media screen and (max-width: 992px) {
  #navbarToggler {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/Navbar.vue